(function () {
    'use strict';
    
    var PRINT_SECTION_SELECTOR = '[data-section-type="summary-recipe"]';
    var PRINT_CONTENT_SELECTOR = '.summary-recipe__recipe';
    var CLEANUP_TIMEOUT = 200;
    var PRINT_DELAY = 150;

    function isMobileChromeLike() {
        var ua = navigator && navigator.userAgent ? navigator.userAgent.toLowerCase() : '';
        return ua.indexOf('crios') !== -1 || (ua.indexOf('chrome') !== -1 && ua.indexOf('mobile') !== -1);
    }

    function isAndroidChrome() {
        var ua = navigator && navigator.userAgent ? navigator.userAgent.toLowerCase() : '';
        return ua.indexOf('android') !== -1 && ua.indexOf('chrome') !== -1;
    }

    function createHiddenIframe() {
        var iframe = document.createElement('iframe');
        iframe.setAttribute('aria-hidden', 'true');
        iframe.setAttribute('tabindex', '-1');
        // Keep the iframe real but off-screen; Chrome on Android can ignore 0x0 iframes for printing
        iframe.style.cssText = 'position:absolute;top:-9999px;left:-9999px;width:1px;height:1px;border:0;opacity:0;';
        // Sandbox with allow-modals needed for print() dialog; allow-popups improves Android Chrome support
        iframe.setAttribute('sandbox', 'allow-same-origin allow-scripts allow-modals allow-popups');
        iframe.src = 'about:blank';
        document.body.appendChild(iframe);
        return iframe;
    }

    function ensureDocumentStructure(targetDoc) {
        if (!targetDoc) {
            return { head: null, body: null };
        }

        var docEl = targetDoc.documentElement;
        if (!docEl) {
            docEl = targetDoc.createElement('html');
            targetDoc.appendChild(docEl);
        }

        var head = targetDoc.head || targetDoc.getElementsByTagName('head')[0];
        if (!head) {
            head = targetDoc.createElement('head');
            docEl.insertBefore(head, docEl.firstChild || null);
        } else {
            // Clear existing content
            while (head.firstChild) {
                head.removeChild(head.firstChild);
            }
        }

        var body = targetDoc.body || targetDoc.getElementsByTagName('body')[0];
        if (!body) {
            body = targetDoc.createElement('body');
            docEl.appendChild(body);
        } else {
            // Clear existing content
            while (body.firstChild) {
                body.removeChild(body.firstChild);
            }
        }

        return { head: head, body: body };
    }

    function cloneStylesIntoHead(head, targetDoc) {
        if (!head || !targetDoc) {
            return;
        }

        var styles = document.querySelectorAll('link[rel="stylesheet"], style');

        for (var i = 0; i < styles.length; i += 1) {
            var original = styles[i];
            var clone;
            
            if (original.tagName === 'LINK') {
                // Only clone stylesheets from same origin or with proper CORS
                clone = targetDoc.createElement('link');
                clone.rel = 'stylesheet';
                clone.href = original.href;
                // Preserve media queries for print styles
                if (original.media) {
                    clone.media = original.media;
                }
            } else if (original.tagName === 'STYLE') {
                clone = targetDoc.createElement('style');
                clone.textContent = original.textContent;
                if (original.media) {
                    clone.media = original.media;
                }
            }
            
            if (clone) {
                head.appendChild(clone);
            }
        }
    }

    function sanitizeContent(element) {
        // Create a clean clone without event handlers
        var clone = element.cloneNode(false);
        
        // Recursively copy child nodes, stripping event attributes
        function copyChildren(source, target) {
            for (var i = 0; i < source.childNodes.length; i++) {
                var child = source.childNodes[i];
                
                if (child.nodeType === 1) { // Element node
                    var childClone = child.cloneNode(false);
                    
                    // Remove all event handler attributes
                    var attrs = childClone.attributes;
                    for (var j = attrs.length - 1; j >= 0; j--) {
                        if (attrs[j].name.toLowerCase().indexOf('on') === 0) {
                            childClone.removeAttribute(attrs[j].name);
                        }
                    }
                    
                    // Skip script tags entirely
                    if (childClone.tagName.toLowerCase() === 'script') {
                        continue;
                    }
                    
                    target.appendChild(childClone);
                    copyChildren(child, childClone);
                } else if (child.nodeType === 3) { // Text node
                    target.appendChild(child.cloneNode(false));
                }
            }
        }
        
        copyChildren(element, clone);
        return clone;
    }

    function stripNonTextualContent(root) {
        if (!root) {
            return;
        }
        var selectors = [
            'img',
            'figure',
            'picture',
            'source',
            'video',
            'svg',
            'iframe',
            'canvas',
            'button',
            'input',
            'textarea',
            'select',
            'option',
            'form',
            'header',
            'footer',
            '[role=\"banner\"]',
            '[role=\"navigation\"]'
        ];
        for (var i = 0; i < selectors.length; i += 1) {
            var nodes = root.querySelectorAll(selectors[i]);
            for (var j = nodes.length - 1; j >= 0; j--) {
                var node = nodes[j];
                if (node && node.parentNode) {
                    node.parentNode.removeChild(node);
                }
            }
        }

        // Remove inline styles to avoid carrying over backgrounds/layout
        var styled = root.querySelectorAll('[style]');
        for (var k = 0; k < styled.length; k++) {
            styled[k].removeAttribute('style');
        }
        if (root.hasAttribute && root.hasAttribute('style')) {
            root.removeAttribute('style');
        }
    }

    function printContent(contentElement) {
        if (!contentElement) {
            if (window && typeof window.print === 'function') {
                window.print();
            }
            return;
        }

        // Chrome on mobile (Android + iOS) can ignore hidden iframes; use a dedicated window there
        var iframe;
        var printWindow;
        var printDoc;
        var usePopup = isMobileChromeLike();

        if (usePopup) {
            printWindow = window.open('', '_blank');
            if (!printWindow) {
                // Popup blocked - fall back to iframe path
                usePopup = false;
            }
        }

        if (!usePopup) {
            iframe = createHiddenIframe();
            printWindow = iframe.contentWindow;
            printDoc = iframe.contentDocument || printWindow.document;
        } else {
            printDoc = printWindow.document;
        }

        var docParts = ensureDocumentStructure(printDoc);
        var head = docParts.head;
        var body = docParts.body;

        if (!head || !body) {
            if (iframe && iframe.parentNode) {
                iframe.parentNode.removeChild(iframe);
            }
            if (usePopup && printWindow && !printWindow.closed) {
                printWindow.close();
            }
            return;
        }

        // Set document title
        printDoc.title = document.title || 'Recipe';

        // Add charset meta tag
        var charset = printDoc.createElement('meta');
        charset.setAttribute('charset', 'UTF-8');
        head.appendChild(charset);

        // Add minimal base print styles (no site CSS)
        var baseStyles = printDoc.createElement('style');
        baseStyles.textContent = 
            '*{margin:0 !important;padding:0 !important;box-sizing:border-box;color:#000 !important;background:transparent !important;} ' +
            'body{font-family:Arial,sans-serif;line-height:1.5;color:#000 !important;padding:12px;} ' +
            '.recipe-print-preview{background:#fff;max-width:100%;} ' +
            'h1{font-size:22px !important;margin:0 0 10px 0 !important;font-weight:bold;} ' +
            'h2{font-size:18px !important;margin:14px 0 8px 0 !important;font-weight:bold;} ' +
            'h3,h4,h5,h6{font-size:16px !important;margin:10px 0 6px 0 !important;font-weight:bold;} ' +
            'p{margin:6px 0 !important;font-size:12pt;} ' +
            'ul,ol{margin:8px 0 8px 20px !important;font-size:12pt;list-style:disc outside !important;} ' +
            'li{margin:4px 0 !important;} ' +
            'a{text-decoration:none !important;} ' +
            'h1,h2,h3,h4,h5,h6{page-break-after:avoid;page-break-inside:avoid;} ' +
            'h1+*,h2+*,h3+*,h4+*,h5+*,h6+*{page-break-before:avoid;} ' +
            'p,li{orphans:2;widows:2;} ' +
            '@media print{' +
            '  @page{margin:12mm;size:letter;} ' +
            '  body{margin:0;padding:12px;} ' +
            '  *{margin:0 !important;padding:0 !important;} ' +
            '  h1{margin:0 0 10px 0 !important;} ' +
            '  h2{margin:14px 0 8px 0 !important;} ' +
            '  h3,h4,h5,h6{margin:10px 0 6px 0 !important;} ' +
            '  p{margin:6px 0 !important;} ' +
            '  ul,ol{margin:8px 0 8px 20px !important;} ' +
            '  li{margin:4px 0 !important;} ' +
            '}';
        head.appendChild(baseStyles);

        // Apply body classes
        body.className = 'recipe-print-preview';

        // Sanitize and append content
        var contentClone = sanitizeContent(contentElement);
        stripNonTextualContent(contentClone);
        body.appendChild(contentClone);

        var cleanupExecuted = false;

        var cleanup = function () {
            if (cleanupExecuted) {
                return;
            }
            cleanupExecuted = true;
            if (iframe && iframe.parentNode) {
                iframe.parentNode.removeChild(iframe);
            }
            if (usePopup && printWindow && !printWindow.closed) {
                printWindow.close();
            }
        };

        // Listen for print completion
        printWindow.addEventListener('afterprint', cleanup, { once: true });

        // Trigger print with fallback cleanup
        window.setTimeout(function () {
            try {
                printWindow.focus();
                printWindow.print();
            } catch (e) {
                console.error('Print failed:', e);
            } finally {
                // Fallback cleanup in case afterprint doesn't fire
                window.setTimeout(cleanup, CLEANUP_TIMEOUT);
            }
        }, PRINT_DELAY);
    }

    function findRecipeContentFromButton(button) {
        var sectionSelector = button.getAttribute('data-print-target') || PRINT_SECTION_SELECTOR;
        var sectionElement = document.querySelector(sectionSelector);

        // Try to find the summary-recipe section if custom selector doesn't match
        if (sectionElement && !sectionElement.matches(PRINT_SECTION_SELECTOR)) {
            sectionElement = sectionElement.closest(PRINT_SECTION_SELECTOR) || sectionElement;
        }

        if (!sectionElement) {
            sectionElement = document.querySelector(PRINT_SECTION_SELECTOR);
        }

        if (!sectionElement) {
            console.warn('Recipe print section not found');
            return null;
        }

        var contentElement = sectionElement.querySelector(PRINT_CONTENT_SELECTOR);
        return contentElement || sectionElement;
    }

    function bindRecipePrintButton(button) {
        if (!button || button.dataset.recipePrintBound === 'true') {
            return;
        }

        button.addEventListener('click', function (event) {
            event.preventDefault();
            var content = findRecipeContentFromButton(button);
            if (content) {
                printContent(content);
            }
        });

        button.dataset.recipePrintBound = 'true';
    }

    function initRecipePrintButtons(context) {
        var scope = context || document;
        var buttons = scope.querySelectorAll('[data-recipe-print-button]');

        if (!buttons.length) {
            return;
        }

        for (var i = 0; i < buttons.length; i += 1) {
            bindRecipePrintButton(buttons[i]);
        }
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            initRecipePrintButtons(document);
        });
    } else {
        initRecipePrintButtons(document);
    }

    // Re-initialize for dynamically loaded sections
    document.addEventListener('shopify:section:load', function (event) {
        initRecipePrintButtons(event.target);
    });
})();
